import { LOGS_PREFIX } from "core/config";
import { categories } from "constants/categories";
const CATEGORIES = categories.join(", ").toLowerCase();

export const MISSING_API_KEY = LOGS_PREFIX + " Missing API key.";
export const PROBABLY_MISSING_API_KEY =
  LOGS_PREFIX + " Failed to load configs, check API key";

export const CANT_OPEN_PANEL_STEALTH_MODE =
  LOGS_PREFIX + " Can't toggle panel in stealth mode";

export const NEW_CONSENT_INVALID_TYPE =
  LOGS_PREFIX + " new consent must be an object";
export const INVALID_CATEGORY =
  LOGS_PREFIX + " Unrecognized category, not one of: " + CATEGORIES;
export const INVALID_SERVICE = LOGS_PREFIX + " Unrecognized service key.";

export const UNKNOWN_BANNER_TYPE = LOGS_PREFIX + " Unrecognized banner type.";

export const CONTEXT_OUTSIDE_PROVIDER =
  LOGS_PREFIX + " useContext outside provider";

export const COOKIE_LOADING_FAILED = LOGS_PREFIX + " Failed to load cookies";
export const BULK_SEND_FAILED =
  LOGS_PREFIX + " Failed to send bulk consent message";

// TCF
export const MISSING_GVL =
  LOGS_PREFIX +
  " Missing Global Vendor List. There is a chance it was still loading. You can check if it exist using: publicAPI > TCFgvl";
export const MISSING_GATP =
  LOGS_PREFIX +
  " Missing Google Ad Technology Providers List (GATP). There is a chance it was still loading. You can check if it exist using: publicAPI > TCFgatp";

export const MISSING_IAB_LIB_NAME = `${LOGS_PREFIX} TCF category with switch is missing IAB LIB name`;
export const MISSING_IAB_LIB_LEGINT_NAME = `${LOGS_PREFIX} TCF category with switch is missing IAB LIB legitimate interest name`;

export const WRONG_TCF_MULTI_CATEGORY_DATA = `${LOGS_PREFIX} Couldn't update categories. Wrong structure of passed data. To update multiple categories expected structure is this: [[categoryName, id], [categoryName, id]]`;
export const WRONG_TCF_SINGLE_CATEGORY_DATA = `${LOGS_PREFIX} Couldn't update category. Wrong structure of passed data. To update single category expected structure is this: [categoryName, id]`;

export const MISSING_AUTOBLOCK =
  "Missing window.CF_cookieAutoblock. Check your consent.js file";
